export const percentageDiscount = (oldPrice: number, currentPrice: number) => {
  const discount = Math.round(((oldPrice - currentPrice) / oldPrice) * 100)
  if (isNaN(discount) || oldPrice <= currentPrice) return ''
  else return '-' + discount + '%'
}
